export default __webpack_public_path__ + "images/logoNoBS.bcea44d9feb017bfe8197df8e683f57b.svg"